import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from "@fortawesome/free-solid-svg-icons";
import logo from "../../../Images/logos/logo.png";

import "./index.css";

const openMobileMenu = () => {  
  console.log('set here....');
  document.querySelector('.mobile__links').setAttribute("style", "width: 250px; margin-right: 0px;");
};

const closeMobileMenu = (e) => {
  e.preventDefault();
  console.log('removed here..');
  document.querySelector('.mobile__links').setAttribute("style", "width: 0px; margin-right: 0px;");
};

export default class NavbarCert extends Component {
  render() {
    return (
      <header className="App-header">
        <div className="container navbar__desk">
          <nav className="navbar d-grid d-grid__columns--3 pt-3">
            <div className="navbar__logo w-100 d-inline-flex flex--left pl-3">
              <Link to="/">
                <img src={logo} alt="GERS - Grow early, rapidly and secxurely"/>
              </Link>
            </div>
            <div className="navbar__menu w-100 mx-auto">
              <div className="navbar__wide w-100">
                <ul className="list-unstyled d-inline-flex navbar__menu w-100">
                  <li className="menu-item px-4"><NavLink to="/certificate/strategyandtactics">Strategy and Tactics</NavLink></li>
                  <li className="menu-item px-4"><NavLink to="/certificate/strategy">Strategy</NavLink></li>
                  <li className="menu-item px-4"><NavLink to="/certificate/staysecureonline">Stay Secure Online</NavLink></li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
        
        
        <div className="navbar__mobile">
          <nav className="navbar d-grid d-grid__columns--mobile pt-1">
            <div className="navbar__logo w-100 text-left pl-4">
              <Link to="/">
                <img src={logo} alt="GERS - Grow early, rapidly and securely"/>
              </Link>
            </div>
            <div className="mobile__menu pr-4">
              <div className="menu__burger w-100">
                  <span onClick={openMobileMenu}><FontAwesomeIcon icon={faBars} size="lg" /></span>
              </div>
              <ul className="list-unstyled mobile__links">
                <a href="http://" className="mobile--close" onClick={closeMobileMenu} alt="Close mobile menu">&times;</a>
                <NavLink to="/certificate/strategyandtactics">Strategy and Tactics</NavLink>
                <NavLink to="/certificate/strategy">Strategy</NavLink>
                <NavLink to="/certificate/staysecureonline">Stay Secure Online</NavLink>
              </ul>
            </div>     
          </nav>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Certificates/Components/Navigation.js